import { jsx as _jsx } from "react/jsx-runtime";
import './OrderRequestTemplates.scss';
import { Base_RequestTemplate } from '../../Page_BaseSandbox/Base_RequestTemplate/index.js';
import { ModuleFE_SandboxOrders } from '../../modules/ModuleFE_SandboxOrders/index.js';
export class OrderRequestTemplates extends Base_RequestTemplate {
    async getTemplates() {
        return ModuleFE_SandboxOrders.listTemplates();
    }
    renderTemplate(template) {
        return _jsx("div", { className: 'predefined-option__label', children: template.label });
    }
}
//# sourceMappingURL=OrderRequestTemplates.js.map